/** @format */
import { useRef, useState } from 'react';
import DefaultImg from '../../../Assets/Images/default.png';
import { error } from '../../../Shared/Components/Toast';
import useApi from '../../../Shared/hooks/api/Index';

const Image = ({ field, onChangeValue, teamForm, setErrors }) => {
	const fileInput = useRef(null);
	const [image, setImage] = useState(
		field?.value === undefined || field?.value == null
			? undefined
			: field?.value,
	);
	const [loading, setLoading] = useState(false);

	const onFileSelect = async () => {
		if (
			field.validation.max_file_size &&
			fileInput.current.files[0]?.size !== undefined
		) {
			let fileSize = parseInt(fileInput.current.files[0]?.size) / 1000;
			if (fileSize > field.validation.max_file_size) {
				let errorMessage = {};
				errorMessage[
					field.name
				] = `حجم تصویر ارسالی نباید بیشتر از KB ${field.validation.max_file_size}  باشد`;
				setErrors(errorMessage);
				return;
			}
		}

		if (field?.validation?.mimes) {
			if (field?.validation?.mimes !== undefined) {
				let value = fileInput.current.files[0]?.type?.replace(
					/^([a-zA-Z]+)\//,
					'',
				);
				let mimes = field?.validation?.mimes?.split(',');
				let findMimes = mimes?.find((m) => m === value);
				if (!findMimes) {
					let errorMessage = {};
					errorMessage[
						field.name
					] = `فرمت تصویر باید ${field.validation.mimes} باشد`;
					setErrors(errorMessage);
					return;
				}
			}
		}

		if (fileInput.current.files[0] === undefined) {
			fileInput.current.value = '';
			setImage(undefined);
		} else {
			setLoading(true);
			let url = teamForm
				? `/user/image-upload?folder=team/${field.name}`
				: `/user/image-upload?folder=users/avatar/${field.name}`;
			await useApi.post(
				url,
				{ photo: fileInput.current.files[0] },
				(res) => {
					onChangeValue(field.name, res.data.data.path ?? res.data.data.url, teamForm);
					setImage(res.data.data.url ?? res.data.data.path);
					setLoading(false);
				},
				(err) => {
					setLoading(false);
					error('هنگام ثبت اطلاعات خطایی رخ داده است');
				},
				true,
			);
		}
		// tempSave({file: file, title: 'test file'});
	};
	return (
		<div className='form-group d-flex flex-column'>
			<label>{field.label}</label>
			{loading ? (
				<div
					style={{ width: '100px', height: '100px' }}
					className='bg-white img-thumbnail c-pointer d-flex flex-row justify-content-center align-items-center'>
					<div
						className='spinner-border spinner-border-sm text-secondary mb-1 mx-2'
						role='status'></div>
				</div>
			) : (
				<>
					<input
						type='file'
						className='d-none'
						ref={fileInput}
						id={`img-${field.id}`}
						onChange={() => onFileSelect()}
					/>
					<img
						onClick={() => {
							let input = document.getElementById(`img-${field.id}`);
							input.click();
						}}
						className='bg-white img-thumbnail c-pointer'
						style={{ width: '100px', height: '100px' }}
						src={image !== undefined && image.length > 0 ? image : DefaultImg}
						alt={field.name}
					/>
				</>
			)}
		</div>
	);
};

export default Image;
